import React, { useEffect, useRef } from 'react';

import { PlacementDetailsContent, PlacementFavoriteProps } from './placement-details';
import { PlacementPopoverAnchor, PlacementPopoverCard } from './styles';
import { FloorplanPlacement } from '../types';
import { placementAnchor } from '../utils/placement-anchor';

interface PlacementDetailsPopoverProps extends PlacementFavoriteProps {
  placement: FloorplanPlacement;
  scale: number;
  onClose: VoidFunction;
}

export const PlacementDetailsPopover = ({
  placement,
  scale,
  onClose,
  isFavoritesEnabled,
  isFavoritesLoaded,
  favoriteResourceUuids,
}: PlacementDetailsPopoverProps): JSX.Element => {
  const { left, top, alignX, alignY } = placementAnchor(placement.geometry);
  const cardRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const card = cardRef.current;

    if (!card) {
      return undefined;
    }

    const stop = (event: Event) => event.stopPropagation();

    card.addEventListener('mousedown', stop);
    card.addEventListener('touchstart', stop);

    return () => {
      card.removeEventListener('mousedown', stop);
      card.removeEventListener('touchstart', stop);
    };
  }, []);

  return (
    <PlacementPopoverAnchor style={{ left, top }}>
      <PlacementPopoverCard
        ref={cardRef}
        data-testid="placement-details-popover"
        scale={scale}
        alignX={alignX}
        alignY={alignY}
      >
        <PlacementDetailsContent
          placement={placement}
          onClose={onClose}
          isCompact
          isFavoritesEnabled={isFavoritesEnabled}
          isFavoritesLoaded={isFavoritesLoaded}
          favoriteResourceUuids={favoriteResourceUuids}
        />
      </PlacementPopoverCard>
    </PlacementPopoverAnchor>
  );
};
